import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../utils/firebase';

export default function Login() {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/select-company');
    } catch (err) {
      setError('Invalid credentials. Please check your email and password.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--black)',
      position: 'relative',
    }}>
      {/* Background grid pattern */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `linear-gradient(rgba(196,160,80,0.03) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(196,160,80,0.03) 1px, transparent 1px)`,
        backgroundSize: '48px 48px',
        pointerEvents: 'none',
      }} />

      <div style={{
        width: 380, animation: 'fadeUp 0.5s ease both',
        position: 'relative', zIndex: 1,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            fontFamily: 'var(--font-display)',
            fontSize: 32, fontWeight: 500,
            color: 'var(--gold-light)',
            letterSpacing: '0.02em', lineHeight: 1,
          }}>InsightPro™</div>
          <div style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10, letterSpacing: '0.3em',
            textTransform: 'uppercase',
            color: 'var(--text-muted)',
            marginTop: 8,
          }}>Retail Intelligence Portal</div>
          <div style={{
            width: 40, height: 1,
            background: 'var(--gold)',
            margin: '16px auto 0', opacity: 0.5,
          }} />
        </div>

        {/* Form */}
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          padding: '32px 32px 28px',
        }}>
          <div style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 9, letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'var(--text-muted)',
            marginBottom: 24,
          }}>Secure Login</div>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: 16 }}>
              <label style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 9, letterSpacing: '0.15em',
                textTransform: 'uppercase',
                color: 'var(--text-muted)',
                display: 'block', marginBottom: 6,
              }}>Email Address</label>
              <input
                type="email" value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  width: '100%', padding: '10px 12px',
                  background: 'var(--surface-2)',
                  border: '1px solid var(--border)',
                  color: 'var(--text-primary)',
                  fontFamily: 'var(--font-body)', fontSize: 13,
                  outline: 'none', transition: 'border-color 0.15s',
                }}
                onFocus={e => e.target.style.borderColor = 'var(--border-gold)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 9, letterSpacing: '0.15em',
                textTransform: 'uppercase',
                color: 'var(--text-muted)',
                display: 'block', marginBottom: 6,
              }}>Password</label>
              <input
                type="password" value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%', padding: '10px 12px',
                  background: 'var(--surface-2)',
                  border: '1px solid var(--border)',
                  color: 'var(--text-primary)',
                  fontFamily: 'var(--font-body)', fontSize: 13,
                  outline: 'none', transition: 'border-color 0.15s',
                }}
                onFocus={e => e.target.style.borderColor = 'var(--border-gold)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            {error && (
              <div style={{
                marginBottom: 16, padding: '10px 12px',
                background: 'rgba(212,95,95,0.1)',
                border: '1px solid rgba(212,95,95,0.25)',
                fontFamily: 'var(--font-mono)',
                fontSize: 10, color: 'var(--red)',
                lineHeight: 1.4,
              }}>{error}</div>
            )}

            <button
              type="submit" disabled={loading}
              style={{
                width: '100%', padding: '12px',
                background: loading ? 'var(--gold-dim)' : 'var(--gold)',
                border: 'none', cursor: loading ? 'default' : 'pointer',
                fontFamily: 'var(--font-mono)',
                fontSize: 11, letterSpacing: '0.2em',
                textTransform: 'uppercase',
                color: loading ? 'var(--gold)' : 'var(--black)',
                fontWeight: 600,
                transition: 'all 0.2s',
              }}
            >{loading ? 'Signing in...' : 'Sign In'}</button>
          </form>
        </div>

        {/* Footer */}
        <div style={{
          textAlign: 'center', marginTop: 20,
          fontFamily: 'var(--font-mono)',
          fontSize: 9, letterSpacing: '0.15em',
          color: 'var(--text-muted)',
        }}>
          InsightPro™ · Confidential Access Only
        </div>
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <span
            onClick={() => navigate('/home')}
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 9, letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: 'var(--gold)', cursor: 'pointer',
              opacity: 0.7, transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => e.target.style.opacity = 1}
            onMouseLeave={e => e.target.style.opacity = 0.7}
          >← Back to Website</span>
        </div>
      </div>
    </div>
  );
}
